import type { ReferenceEmbed } from '@cult/schemas';
import { Flex } from 'antd';
import type { CSSProperties } from 'react';
import { FRAMEWORK_TAG_SHAPE, ReferenceTag } from '../ReferenceTag/ReferenceTag';

type Props = {
  /** A praise or direct feedback — anything tagged with core values and frameworks. */
  tags: { coreValues: ReferenceEmbed[]; frameworks: ReferenceEmbed[] };
  style?: CSSProperties;
};

/** A record's core values followed by its frameworks. Renders nothing for an untagged record. */
export const ReferenceTags = ({ tags, style }: Props) => {
  if (tags.coreValues.length + tags.frameworks.length === 0) return null;
  return (
    <Flex gap={6} wrap style={style}>
      {tags.coreValues.map((tag) => (
        <ReferenceTag key={tag.id} value={tag} />
      ))}
      {tags.frameworks.map((tag) => (
        <ReferenceTag key={tag.id} value={tag} shape={FRAMEWORK_TAG_SHAPE} />
      ))}
    </Flex>
  );
};
